import { render, staticRenderFns } from "./viewqueries.vue?vue&type=template&id=9633275c&scoped=true"
import script from "./viewqueries.vue?vue&type=script&lang=js"
export * from "./viewqueries.vue?vue&type=script&lang=js"
import style0 from "./viewqueries.vue?vue&type=style&index=0&id=9633275c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9633275c",
  null
  
)

export default component.exports